import { Box, useTheme } from "@mui/material";
import { uploadFilesTableActions } from "../../../data/upload-files-table";
import Image from "../../common/Image";
import { ActionsRowCta } from "../../../models/uploaded-file";

interface ActionsRowProps {
  onAction: (cta: ActionsRowCta) => void;
  isPreviewDisabled?: boolean;
}

export interface ActionButton {
  iconSrc: string;
  cta: ActionsRowCta;
}

const ActionsRow = ({ onAction, isPreviewDisabled }: ActionsRowProps) => {
  const theme = useTheme();

  const onActionClick = (ev: MouseEvent, cta: ActionsRowCta) => {
    ev.stopPropagation();
    if (cta === ActionsRowCta.VIEW && isPreviewDisabled) return;

    onAction(cta);
  };
  return (
    <Box sx={{ ...theme.customStyles.flexStart, height: "100%", gap: "10px" }}>
      {uploadFilesTableActions.map((button) => (
        <Image
          key={button.cta}
          onClick={(ev) => onActionClick(ev, button.cta)}
          sx={{
            cursor: "pointer",
            pointerEvents:
              button.cta === ActionsRowCta.VIEW && isPreviewDisabled
                ? "none"
                : "all",
            opacity:
              button.cta === ActionsRowCta.VIEW && isPreviewDisabled ? 0.3 : 1,
          }}
          src={button.iconSrc}
        />
      ))}
    </Box>
  );
};

export default ActionsRow;
